import { TImageExcerpt } from '@/domain/Images.domain';
import { apiImageInstance } from '../Axios';
import { ApiUrls } from '@/service/constants/urls';

export const getImagesInSearch = (activity_ids: string): Promise<TImageExcerpt> | TImageExcerpt => {
    if (!activity_ids) return {} as TImageExcerpt;

    return apiImageInstance
        .get<TImageExcerpt>(ApiUrls.photo.excerptAll, { params: { activity_ids: activity_ids } })
        .then(({ data }) => {
            if (data && typeof data === 'object') {
                return data;
            }
            return {};
        })
        .catch((err) => {
            console.error(err);
            return {} as TImageExcerpt;
        });
};
